import { MTypography } from 'src/lib';
import { InvestigationCategoryName } from 'src/models';
import { Color, Spacing } from 'src/styles';

interface CipFailureDescriptionProps {
  category: InvestigationCategoryName;
}

export const InvestigationCipFailureDescription = ({ category }: CipFailureDescriptionProps) => {
  if (category === InvestigationCategoryName.NameOrDateOfBirth) {
    return (
      <div className={Spacing.mb16}>
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray8}>
          Proof of Name and/or Date of Birth is required
        </MTypography>
        <MTypography variant='body1' color={Color.Gray7}>
          Additional document(s) to validate Name and/or Date of Birth are required to process your application.
        </MTypography>
      </div>
    );
  }

  if (category === InvestigationCategoryName.TaxId) {
    return (
      <div className={Spacing.mb16}>
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray8}>
          Proof of Tax Identification is required
        </MTypography>
        <MTypography variant='body1' color={Color.Gray7}>
          Additional document(s) to validate your Tax Identification Number are required to process your application.
        </MTypography>
      </div>
    );
  }

  if (category === InvestigationCategoryName.Address) {
    return (
      <div className={Spacing.mb16}>
        <MTypography variant='subtitle1' weight='bold' color={Color.Gray8}>
          Proof of Address is required
        </MTypography>
        <MTypography variant='body1' color={Color.Gray7}>
          Additional document(s) to validate your Address are required to process your application.
        </MTypography>
      </div>
    );
  }

  return null;
};
